import { ReactNode, createContext, useContext } from "react";
import useTransactionHelper from "./transaction-helper";

const TransactionHelperContext = createContext(
  {} as ReturnType<typeof useTransactionHelper>
);
export function useTransactionHelperContext() {
  return useContext(TransactionHelperContext);
}

interface TransactionHelperProviderProps {
  children: ReactNode;
}
export function TransactionHelperProvider({
  children,
}: TransactionHelperProviderProps) {
  return (
    <TransactionHelperContext.Provider value={useTransactionHelper()}>
      {children}
    </TransactionHelperContext.Provider>
  );
}
